module.exports = __webpack_public_path__ + "img/Q.08b767c7.jpg";